import { CardBrand } from "univapay-node";

export const obfuscateCvv = (cardBrand: CardBrand): string => {
    if (!cardBrand) {
        return "";
    }

    switch (cardBrand) {
        case CardBrand.AMEX:
            return "*".repeat(4);
        default:
            return "*".repeat(3);
    }
};

export const obfuscateCardNumber = (cardBrand: CardBrand, lastFour: string): string => {
    if (!cardBrand) {
        return "";
    }

    switch (cardBrand) {
        case CardBrand.AMEX:
            return "*".repeat(4) + " " + "*".repeat(6) + " " + "*" + lastFour;
        case CardBrand.DINERS:
            return "*".repeat(4) + " " + "*".repeat(6) + " " + lastFour;
        default:
            return "*".repeat(4) + " " + "*".repeat(4) + " " + "*".repeat(4) + " " + lastFour;
    }
};
